// CD: components/pdp-extras/SizeChartModal.jsx — header swipe only; PusheDialog owns focus and scroll.
class SizeChartElement extends HTMLElement {
  #zoom = event => {
    const button=event.target.closest?.('.pushe-chart__zoom');
    const product=this.closest('pushe-product');
    if (!button || typeof product?.openImage !== 'function') return;
    // Chart clicks are independent of the gallery's remembered drag suppression.
    event.stopPropagation();product.openImage(button);
  };
  #start = null;
  #down = event => {
    this.#start = null;
    const head = event.target.closest?.('.pushe-chart__head');
    if (!head || event.target.closest('button') || event.isPrimary === false || !matchMedia('(max-width:899px)').matches) return;
    this.#start = { id:event.pointerId, x:event.clientX, y:event.clientY };
    try { head.setPointerCapture(event.pointerId); } catch { /* Synthetic events have no active pointer. */ }
  };
  #up = event => {
    const start = this.#start; this.#start = null;
    if (start?.id === event.pointerId && event.clientY-start.y>64 && event.clientY-start.y>Math.abs(event.clientX-start.x)*1.3) this.querySelector('pushe-dialog')?.close();
  };
  #cancel = () => { this.#start = null; };
  connectedCallback() {
    this.addEventListener('click',this.#zoom);
    this.addEventListener('pointerdown',this.#down);
    this.addEventListener('pointerup',this.#up);
    this.addEventListener('pointercancel',this.#cancel);
    this.addEventListener('pushe:dialog:close',this.#cancel);
  }
  disconnectedCallback() {
    this.removeEventListener('click',this.#zoom);
    this.removeEventListener('pointerdown',this.#down);
    this.removeEventListener('pointerup',this.#up);
    this.removeEventListener('pointercancel',this.#cancel);
    this.removeEventListener('pushe:dialog:close',this.#cancel);
    this.#cancel();
  }
}
if (!customElements.get('pushe-size-chart')) customElements.define('pushe-size-chart',SizeChartElement);
